import React from 'react'
import './Notif.css'
import Pill from '../Pill/Pill'

const Notif = ({Message}) => {
  

  return (
   <dialog id='ErrorDial'>

      {Message}
      
      <Pill bgcolor={'#e8c133'} bordercolor={'transparent'} classe={'BtnDialog'} color={'#000'} onclick={e=>{e.currentTarget.parentNode.close()}} text={'Fermer'}/>

   </dialog>
  )
}

export default Notif